import React, { useState, useEffect } from "react";
import { Modal, Table, Tag, message, Button } from "antd";
import { HistoryOutlined, EditOutlined } from "@ant-design/icons";
import useAxios from "../../utilities/useAxios";
import dayjs from "dayjs";
import EditTransferRecordModal from "./EditTransferRecordModal";

const ViewTransferRecordsModal = ({ visible, onCancel, userId, userName }) => {
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);
	const [editModalVisible, setEditModalVisible] = useState(false);
	const [selectedTransferRecord, setSelectedTransferRecord] =
		useState(null);

	useEffect(() => {
		if (visible && userId) {
			fetchRecords();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- run only when visible/userId
	}, [visible, userId]);

	const fetchRecords = async () => {
		try {
			setLoading(true);
			const response = await useAxios.get(
				`/users/transfer-records/${userId}/`
			);
			if (response.status === 200) {
				setRecords(response.data);
			}
		} catch (error) {
			message.error("이명 기록을 불러오는데 실패했습니다.");
		} finally {
			setLoading(false);
		}
	};

	const handleEdit = (record) => {
		setSelectedTransferRecord(record);
		setEditModalVisible(true);
	};

	const handleEditSuccess = () => {
		setEditModalVisible(false);
		setSelectedTransferRecord(null);
		fetchRecords(); // Refresh the list
	};

	const handleEditCancel = () => {
		setEditModalVisible(false);
		setSelectedTransferRecord(null);
	};

	const getTransferColor = (type) => {
		switch (type) {
			case "전입":
				return "green";
			case "전출":
				return "red";
			default:
				return "default";
		}
	};

	const columns = [
		{
			title: "이명일",
			dataIndex: "transfer_date",
			key: "transfer_date",
			render: (date) => dayjs(date).format("YYYY-MM-DD"),
			sorter: (a, b) =>
				dayjs(a.transfer_date).unix() -
				dayjs(b.transfer_date).unix(),
			defaultSortOrder: "descend",
		},
		{
			title: "이명 유형",
			dataIndex: "transfer_type",
			key: "transfer_type",
			render: (type) => (
				<Tag color={getTransferColor(type)}>{type}</Tag>
			),
		},
		{
			title: "상대교회",
			dataIndex: "corressponding_church",
			key: "corressponding_church",
			render: (church) => church || "-",
		},
		{
			title: "이명사유",
			dataIndex: "reason",
			key: "reason",
			render: (reason) => reason || "-",
		},
		{
			title: "작업",
			key: "actions",
			render: (_, record) => (
				<Button
					type="primary"
					size="small"
					icon={<EditOutlined />}
					onClick={() => handleEdit(record)}>
					수정
				</Button>
			),
		},
	];

	return (
		<>
			<Modal
				title={
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: "8px",
						}}>
						<HistoryOutlined />
						<span>
							{userName}님의 이명 기록
						</span>
					</div>
				}
				open={visible}
				onCancel={onCancel}
				footer={null}
				width={800}>
				<Table
					columns={columns}
					dataSource={records}
					rowKey="id"
					loading={loading}
					pagination={{
						pageSize: 10,
						showSizeChanger: true,
						showQuickJumper: true,
						showTotal: (total, range) =>
							`${range[0]}-${range[1]} / 총 ${total}개`,
					}}
					locale={{
						emptyText: "이명 기록이 없습니다.",
					}}
				/>
			</Modal>

			{/* Edit Transfer Record Modal */}
			<EditTransferRecordModal
				visible={editModalVisible}
				onCancel={handleEditCancel}
				onSuccess={handleEditSuccess}
				transferRecord={selectedTransferRecord}
			/>
		</>
	);
};

export default ViewTransferRecordsModal;
